// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe_subscribe__3Gh6a"};